module.exports = __webpack_public_path__ + "fae69c9841aaebe43661ae750d1db590.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/accordion-s.png
// module id = 1835
// module chunks = 0